import { PaginazioneDTO } from "./paginazioneDTO";
import { DettaglioErroreDTO } from "./dettaglio-erroreDTO";

export class BaseResponseDTO {
  stato: string;
  descrizione: string;
  paginazione: PaginazioneDTO
  errori: DettaglioErroreDTO[];
}
